module.exports = __webpack_public_path__ + "media/effects-15.55572e67.webm";